import api from '../../assets/js/api.js'

const state = {
  shopList: {
    data: [],
    links: {
      next: null
    },
    meta: {}
  },
  shopListCat: {
    data: [],
    links: {
      next: null
    },
    meta: {}
  },
  shopTeaserList: {
    data: [],
    links: {
      next: null
    },
    meta: {}
  },
  shop: null,
  products: {
    data: [],
    links: {
      next: null
    },
    meta: {}
  }
}

const getters = {
  shop_get_list: state => {
    return state.shopList
  },
  shop_get_list_cat: state => {
    return state.shopListCat
  },
  shop_get_teaser_list: state => {
    return state.shopTeaserList
  },
  shop_get_details: state => {
    return state.shop
  },
  shop_get_product_list: state => {
    return state.products
  }
}

const mutations = {
  SHOP_SET_LIST (state, shopList) {
    state.shopList = shopList
  },
  SHOP_SET_LIST_FROM_CATEGORY (state, shopList) {
    state.shopListCat = shopList
  },
  SHOP_LIST_PAGE (state, shopList) {
    var data = state.shopList.data.concat(shopList.data)
    state.shopList = {
      data: data,
      links: shopList.links,
      meta: shopList.meta
    }
  },
  SHOP_LIST_CAT_PAGE (state, shopList) {
    var data = state.shopListCat.data.concat(shopList.data)
    state.shopListCat = {
      data: data,
      links: shopList.links,
      meta: shopList.meta
    }
  },
  SHOP_RESET_LIST (state) {
    state.shopList = []
  },
  SHOP_SET_TEASER_LIST (state, shopTeaserList) {
    state.shopTeaserList = shopTeaserList
  },
  SHOP_SET_DETAILS (state, shop) {
    state.shop = shop
  },
  SHOP_SET_PRODUCT_LIST (state, products) {
    state.products = products
  },
  SHOP_PRODUCT_LIST_PAGE (state, productList) {
    var data = state.products.data.concat(productList.data)
    state.products = {
      data: data,
      links: productList.links,
      meta: productList.meta
    }
  },
  SHOP_SET_STATUS (state, event) {
    const shopList = state.shopList.data.find((obj) => {
      return obj.uid === event.shop
    })
    if (shopList !== undefined) {
      shopList.is_online = event.connectionStatus
    }
    const shopTeaserList = state.shopTeaserList.data.find((obj) => {
      return obj.uid === event.shop
    })
    if (shopTeaserList !== undefined) {
      shopTeaserList.is_online = event.connectionStatus
    }
    if (state.shop && state.shop.uid === event.shop) {
      state.shop.is_online = event.connectionStatus
    }
  }
}

const actions = {
  getShopList ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getShopList')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getShopList')
      api.getShopList(12).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopList')
          console.log(response)
          commit('SHOP_SET_LIST', response)
          if (payload && payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopList')
          console.log(error)
          if (payload && payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getShopListByCat ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getShopListByCat')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getShopListByCat')
      api.getShopsByCategory(payload, 16).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopListByCat')
          console.log(response)
          commit('SHOP_SET_LIST_FROM_CATEGORY', response)
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopListByCat')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getShopTeaserList ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getShopTeaserList')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getShopTeaserList')
      api.getShopList(6).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopTeaserList')
          console.log(response)
          var index = -1
          for (var s in response.data) {
            if (response.data[s].uid === payload.shop) {
              index = s
            }
          }
          if (index >= 0) {
            response.data.splice(index, 1)
          }
          commit('SHOP_SET_TEASER_LIST', response)
          if (payload && payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopTeaserList')
          console.log(error)
          if (payload && payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getShopDetails ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getShopDetails')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getShopDetails')
      api.getShopDetails(payload.uid).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopDetails')
          console.log(response.data)
          commit('SHOP_SET_DETAILS', response.data)
          if (payload && payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopDetails')
          console.log(error)
          if (payload && payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getShopProductList ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getShopProductList')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getShopProductList')
      api.getShopProductList(payload, 12).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopProductList')
          console.log(response)
          commit('SHOP_SET_PRODUCT_LIST', response)
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopProductList')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getShopProductTeaserList ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getShopProductTeaserList')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getShopProductTeaserList')
      api.getShopProductList(payload, 6).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopProductTeaserList')
          console.log(response)
          commit('SHOP_SET_PRODUCT_LIST', response)
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getShopProductTeaserList')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/shop.js